import {
    CANNEDCOMMAND_CREATE_EDIT_OPEN_MODAL,
    CANNEDCOMMAND_CREATE_REQUEST,
    CANNEDCOMMAND_CREATE_RESULT,
    CANNEDCOMMAND_UPDATE_REQUEST,
    CANNEDCOMMAND_UPDATE_RESULT,
    CANNEDCOMMAND_GET_REQUEST,
    CANNEDCOMMAND_GET_RESULT,
} from 'Redux/actionTypes';

export const cannedCommandCreateEditOpenModal = (data) => ({
    type: CANNEDCOMMAND_CREATE_EDIT_OPEN_MODAL,
    payload: data
})

export const cannedCommandCreateRequest = (data) => ({
    type: CANNEDCOMMAND_CREATE_REQUEST,
    payload: data
})

export const cannedCommandCreateResult = (result) => ({
    type: CANNEDCOMMAND_CREATE_RESULT,
    payload: result
})

export const cannedCommandUpdateRequest = (data) => ({
    type: CANNEDCOMMAND_UPDATE_REQUEST,
    payload: data
})

export const cannedCommandUpdateResult = (result) => ({
    type: CANNEDCOMMAND_UPDATE_RESULT,
    payload: result
})

export const cannedCommandGetRequest = (data) => ({
    type: CANNEDCOMMAND_GET_REQUEST,
    payload: data
})

export const cannedCommandGetResult = (result) => ({
    type: CANNEDCOMMAND_GET_RESULT,
    payload: result
})